import React from 'react';
import clsx from 'clsx';
import Depot from '../../_shared/depot';
import * as styles from './style.module.css';
import { IconCheck, IconMinus } from '../../__generated__';
import Paragraph from '../../Typography/Paragraph';
const CheckboxWithoutRef = ({ error, fullWidth = false, id, inderterminate = false, label, leadingLabel = false, rightAlignLabel = false, type = 'checkbox', ...commonProps }) => {
    const isLabelRightAligned = fullWidth && rightAlignLabel;
    const rootClasses = clsx(styles.root, {
        [styles.inputFullWidth]: fullWidth,
        [styles.rootReversed]: leadingLabel,
    });
    const inputClasses = clsx(styles.input, { [styles.error]: error });
    const iconClasses = clsx({
        [styles.iconAlignLeft]: !leadingLabel,
        [styles.iconAlignRight]: leadingLabel,
    });
    const labelClasses = clsx(styles.label, {
        [styles.labelFullWidth]: fullWidth,
        [styles.labelLeading]: leadingLabel,
        [styles.labelTextAlignRight]: isLabelRightAligned,
        [styles.labelTextAlignLeft]: !isLabelRightAligned,
        [styles.labelTrailing]: !leadingLabel,
    });
    return (React.createElement("div", { className: rootClasses },
        Depot.createElement('input', {
            className: inputClasses,
            id,
            type,
            ...commonProps,
        }),
        inderterminate ? (React.createElement(IconMinus, { className: iconClasses, size: 24, "aria-hidden": true })) : (React.createElement(IconCheck, { className: iconClasses, size: 24, "aria-hidden": true })),
        React.createElement("label", { className: labelClasses, htmlFor: id },
            React.createElement(Paragraph, { typeStyle: "body" }, label))));
};
const Checkbox = Depot.withRef(CheckboxWithoutRef);
Checkbox.displayName = 'Checkbox';
export default Checkbox;
//# sourceMappingURL=index.js.map